
        import normalize from "../../../node_modules/san-loader/lib/runtime/normalize.js";
        var injectStyles = [];

        import template from '/Users/steinitz/github/san-cli-plugin-devtools/src/components/home/Home.san?lang=html&san=&type=template'
        
    import script from '/Users/steinitz/github/san-cli-plugin-devtools/src/components/home/Home.san?lang=js&san=&type=script';
    export * from '/Users/steinitz/github/san-cli-plugin-devtools/src/components/home/Home.san?lang=js&san=&type=script';
    
        export default normalize(script, template, injectStyles);
        /* san-hmr component */
    